<template>
  <div class="base-timeline" id="base-timeline">
    <base-section>
      <div class="container">
        <div class="timeline-items">
          <div class="timeline-item timeline-item-1-4" :class="{ 'active': step === 1 }">
            <div class="timeline-item-content">
              <span class="timeline-item-number">01</span>
              <span class="timeline-item-text">{{$t('components.timeline.flight_selection')}}</span>
            </div>
          </div>

          <div class="timeline-item timeline-item-1-4" :class="{ 'active': step === 2 }">
            <div class="timeline-item-content">
              <span class="timeline-item-number">02</span>
              <span class="timeline-item-text">{{$t('components.timeline.passenger_information')}}</span>
            </div>
          </div>

          <div class="timeline-item timeline-item-1-4" :class="{ 'active': step === 3 }">
            <div class="timeline-item-content">
              <span class="timeline-item-number">03</span>
              <span class="timeline-item-text">{{$t('components.timeline.review_information')}}</span>
            </div>
          </div>

          <div class="timeline-item timeline-item-1-4" :class="{ 'active': step === 4 }">
            <div class="timeline-item-content">
              <span class="timeline-item-number">04</span>
              <span class="timeline-item-text">{{$t('components.timeline.reservation_confirmation')}}</span>
            </div>
          </div>
        </div>
      </div>
    </base-section>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState( 'timelineModule', [
      'step'
    ])
  }
}
</script>